// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { IJsonQueryDeveloper } from 'packages/api-models/common/json_query';
import { PIK_PROMO } from 'shared/constants/specialPromos';
import { getGeoValueByType, getTermsValue, resetTerms, setGeo, setTerm, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'builder';

export const builderTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, geoTags }) => {
    const builders = getTermsValue('builders_ids')(jsonQuery);

    if (!builders?.length) {
      return null;
    }

    return builders.map(builderId => {
      const label = geoTags.developers[builderId] || `Неизвестный застройщик #${builderId}`;

      return { label, value: createTagValue(ID, String(builderId)) };
    });
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const builders = getTermsValue('builders_ids')(jsonQuery);

    if (!builders) {
      return jsonQuery;
    }

    const nextBuildersIds = builders.filter(id => String(id) !== removingTagValue);
    let newJsonQuery = resetTerms(['builders_ids', 'builder'])(jsonQuery);

    if (String(PIK_PROMO.developerId) === removingTagValue) {
      newJsonQuery = resetTerms(['is_pik_promo'])(newJsonQuery);
    }

    if (nextBuildersIds.length) {
      newJsonQuery = setTerms('builders_ids')(newJsonQuery)(nextBuildersIds);

      if (nextBuildersIds.length === 1) {
        newJsonQuery = setTerm('builder')(newJsonQuery)(nextBuildersIds[0]);
      }
    }

    const values = getGeoValueByType<IJsonQueryDeveloper>('builder')(newJsonQuery);

    if (!values) {
      return newJsonQuery;
    }

    const newValues = values.filter(({ id }) => String(id) !== removingTagValue);

    return setGeo()(newJsonQuery)(newValues);
  },
};
